module.exports = __webpack_public_path__ + "./images/35f31c27290b12e88174f0a49de3aba4.webp";